export default "__VITE_ASSET__920e767e__"